class Plans {
  plansElement: HTMLElement;
  cards: NodeListOf<HTMLElement>;
  link: HTMLAnchorElement

  constructor(plansElement: HTMLElement) {
    this.plansElement = plansElement;
    this.cards = plansElement.querySelectorAll<HTMLElement>(".plans__card");
    this.link = plansElement.querySelector(".plans__link") as HTMLAnchorElement;
    this.init();
  }

  init() {
    this.cards.forEach(card => {
      
      card.addEventListener("click", () => {
        this.setActiveCard(card);

        if(card.classList.contains("active")) {
          this.link.href = card.dataset.link ?? "";
          this.link.classList.add("active");
        }
      });
    });

    this.link.addEventListener("click", (e) => {
      if (!this.link.classList.contains("active")) {
        e.preventDefault();
        return;
      }

      const targetUrl = this.link.getAttribute("href")?.trim() ?? "";

      if (!targetUrl) {
        e.preventDefault();
      }
    });
  }

  setActiveCard(activeCard: HTMLElement) {
    this.cards.forEach(card => card.classList.remove("active"));

    activeCard.classList.add("active");
  }
}

document.querySelectorAll<HTMLElement>(".plans").forEach(plansEl => {
  new Plans(plansEl);
});
